export function parseJwt(token) {
	try {
		return JSON.parse(atob(token.split('.')[1]));
	} catch (_e) {
		return null;
	}
}

function cleanAccessToken(accessTokenString) {
	return accessTokenString.replace('Bearer ', '');
}

function getExpiry(accessToken) {
	const parsed = parseJwt(cleanAccessToken(accessToken));
	if (!parsed || !parsed.exp) {
		return null;
	}
	const { exp } = parsed;
	// multiply by 1000 to account for difference between Rails and JS dates
	return exp * 1000;
}

export function checkExpired(accessToken) {
	if (!accessToken) {
		return false;
	}
	const expiry = getExpiry(accessToken);
	return expiry ? new Date().getTime() >= expiry - 2000 : false;
}

export function formatAccessToken(accessToken) {
	if (!accessToken) {
		return null;
	}
	const cleanedToken = cleanAccessToken(accessToken);
	return `Bearer ${cleanedToken}`;
}
